import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  component: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  componentcontact: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  itemcenter: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  maintext: {
    color: "#595A5A",
    fontSize: "2rem",
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  title: {
    fontWeight: 700,
    fontSize: "1.2rem",
    color: "#595A5A",
    marginTop: "0.5rem",
  },
  value: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
    whiteSpace: "break-spaces",
    textAlign: "center",
    marginTop: "0.5rem",
  },
}));

const Contactus = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const contact = [
    {
      title: lang.Address,
      image: require("../../images/graphic-icon/contract_address-01.png"),
      value: lang.AddressMEA,
    },
    {
      title: lang.Email,
      image: require("../../images/graphic-icon/contact_email-01.png"),
      value: "apigis@mea.or.th",
    },
    {
      title: lang.Phone,
      image: require("../../images/graphic-icon/contact_phone-01.png"),
      value: "02-611-5357\n02-611-5630",
    },
  ];

  return (
    <>
      <Grid item xs={12}>
        <div className={classes.component}>
          <Typography id="contactus" className={classes.maintext}>
            {lang.Contactus}
          </Typography>
          {/* <div className={classes.itemcenter}>
            <Typography className={classes.secondtext}>
              Usu habeo equidem sanctus no. Suas summo id sed, erat erant
              oporteat cu pri.
            </Typography>
          </div> */}
        </div>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          {contact.map((item, index) => {
            return (
              <Grid
                item
                md={4}
                sm={12}
                key={`${item.title}_${index}`}
                className={classes.component}
              >
                <img
                  alt={item.title}
                  src={item.image}
                  style={{ width: "auto", height: "3.5rem" }}
                />
                <Typography className={classes.title}>{item.title}</Typography>
                <Typography className={classes.value}>{item.value}</Typography>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </>
  );
};

export default Contactus;
